import { ZoomNoLicenseString, zoomNoLicenseString, ZoomType, ZoomTypeLabelMap } from '@airreading/common/data';

export function getZoomLicenseTypeLabel(type: ZoomType | ZoomNoLicenseString | null | undefined): string {
  if (!type || type === zoomNoLicenseString) {
    return zoomNoLicenseString;
  }

  return ZoomTypeLabelMap[type] ?? zoomNoLicenseString;
}
